"use client";

import React from "react";
import type { TocItem } from "@/lib/post";

interface TableOfContentsProps {
  toc: TocItem[] | null;
  variant?: "rail" | "disclosure";
}

function TocList({ toc }: { toc: TocItem[] }) {
  return (
    <ol className="toc">
      {toc.map((item) => (
        <li key={item.id}>
          <a href={`#${item.id}`} data-toc={item.id}>
            {item.text}
          </a>
          {item.children && item.children.length > 0 ? (
            <ol>
              {item.children.map((child) => (
                <li key={child.id}>
                  <a href={`#${child.id}`} data-toc={child.id}>
                    {child.text}
                  </a>
                </li>
              ))}
            </ol>
          ) : null}
        </li>
      ))}
    </ol>
  );
}

export const TableOfContents: React.FC<TableOfContentsProps> = ({
  toc,
  variant = "disclosure",
}) => {
  if (!toc || toc.length <= 1) return null;

  if (variant === "rail") {
    return (
      <aside className="toc-rail" aria-label="On this page">
        <p className="toc-h">On this page</p>
        <TocList toc={toc} />
      </aside>
    );
  }

  return (
    <details className="toc-box">
      <summary>
        On this page <span className="toc-n">{toc.length} sections</span>
      </summary>
      <TocList toc={toc} />
    </details>
  );
};
